import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UsersListState } from "../../../Interfaces/ReduxSliceInterface";
import { User, UsersListResponse } from "../../../Interfaces/UsersInterface";

const initialState: UsersListState = {
  users: [] as User[],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  size: 20,
};

const usersListSlice = createSlice({
  name: "usersList",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      if (action.payload) {
        state.users = [];
        state.total = 0;
      }
    },
    setUsers: (state, action: PayloadAction<UsersListResponse>) => {
      const items = action.payload.items ?? [];
      state.users = items.map((u) => ({
        _id: u._id,
        userName: u.representative?.fullName ?? "",
        email: u.email,
        permissionGroup: u.permissions || [],
        role: (u.roles && u.roles[0]) || "",
        phone: u.phone || undefined,
        facilityId: u.facilityId ?? undefined,
        isActive: u.isActive ?? true,
      }));
      state.total = action.payload.total ?? items.length;
      state.page = action.payload.page ?? 1;
      state.size = action.payload.size ?? 20;
      state.loading = false;
      state.error = null;
    },
    clearUsers: (state) => {
      state.users = [];
      state.error = null;
      state.total = 0;
      state.page = 1;
      state.size = 20;
    },
    updateUser: (state, action: PayloadAction<User>) => {
      const index = state.users.findIndex(
        (user) => user._id === action.payload._id
      );
      if (index !== -1) {
        state.users[index] = action.payload;
      }
    },
    removeUser: (state, action: PayloadAction<string>) => {
      state.users = state.users.filter((user) => user._id !== action.payload);
      state.total = state.users.length;
    },
  },
});

export const { setLoading, setError, setUsers, clearUsers, updateUser, removeUser } = usersListSlice.actions;
export default usersListSlice.reducer;
